module.exports = __webpack_public_path__ + "static/media/settings-background.f14cb4a8.jpg";